class Top {
  constructor(root) {
    this.root = root;
    // mvスライダ-
    this.mvSwiperEl = root.querySelector(".js-mv-swiper");
    this.mvSwiper = null;
    // thoughtスライダー（画像のフェードイン）
    this.thoughtSwiperEl = root.querySelector(".js-thought-swiper");
    // works pin
    this.worksPinEl = root.querySelector(".js-works-pin");
    this.worksPinTriggers = [];

    this.mvSwiperDestroy = null;
    this.resizeHandler = null;

    this.init();
    this.mount();
  }
  init() {
    // TODO 260424 一時非表示
    // if (this.mvSwiperEl) {
    //   this.mvSwiperInit();
    // }

    if (this.worksPinEl && !isMobile()) {
      this.worksPinInit();
    }

    this.thoughtSwiperEl && this.thoughtSwiperInit();

    this.resizeBind();
  }

  mount() {}
  thoughtSwiperInit() {
    new Swiper(this.thoughtSwiperEl, {
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 3000,
      },
      speed: 2000,
      allowTouchMove: false,
    });
  }
  debounce(func, wait = 300) {
    let timer = null;

    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, wait);
    };
  }
  mvSwiperInit() {
    if (this.mvSwiperEl.dataset.swiperInit === "1") return;
    this.mvSwiperEl.dataset.swiperInit = "1";

    const SLIDE_STAY = 8;
    const tls = [];
    let currentTL = null;

    const setSlide = (slideEl) => {
      if (!slideEl) return;

      gsap.set(slideEl.querySelectorAll(".js-mv-swiper__text .in-picture"), {
        opacity: 0,
        y: 100,
        x: -50,
      });

      gsap.set(slideEl.querySelector(".js-mv-swiper__people"), {
        opacity: 0,
        y: 100,
        x: -100,
      });
    };

    const buildStartTL = (slideEl) => {
      const tl = gsap.timeline();

      tl.to(slideEl.querySelector(".js-mv-swiper__people"), {
        opacity: 1,
        y: 0,
        x: 0,
        duration: 0.3,
      }).to(
        slideEl.querySelectorAll(".js-mv-swiper__text .in-picture"),
        {
          opacity: 1,
          y: 0,
          x: 0,
          duration: 0.3,
          stagger: 0.1,
        },
        "<=0.1",
      );

      return tl;
    };

    const buildEndTL = (slideEl) => {
      const tl = gsap.timeline();

      tl.to(slideEl.querySelector(".js-mv-swiper__people"), {
        opacity: 0,
        duration: 0.3,
      }).to(
        slideEl.querySelectorAll(".js-mv-swiper__text .in-picture"),
        {
          opacity: 0,
          y: -30,
          x: 30,
          duration: 0.2,
          stagger: 0.05,
        },
        "=",
      );

      return tl;
    };

    const getOrCreateTL = (slideEl, swiper) => {
      let tl = slideEl._mvTL;
      if (tl) return tl;

      setSlide(slideEl);

      tl = gsap.timeline({ paused: true });

      tl.add(buildStartTL(slideEl), "start")
        .to({}, { duration: SLIDE_STAY }, "hold")
        .add(buildEndTL(slideEl), "end")
        .call(() => {
          swiper.slideNext();
        });

      slideEl._mvTL = tl;
      tls.push(tl);

      return tl;
    };

    const playActive = (swiper) => {
      const slideEl = swiper.slides[swiper.activeIndex];
      const nextIndex = (swiper.activeIndex + 1) % swiper.slides.length;
      const nextSlideEl = swiper.slides[nextIndex];

      setSlide(nextSlideEl);

      if (currentTL) {
        currentTL.pause(0);
      }

      const tl = getOrCreateTL(slideEl, swiper);
      currentTL = tl;

      setSlide(slideEl);
      tl.restart(true);
    };

    this.mvSwiper = new Swiper(this.mvSwiperEl, {
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      speed: 10,
      allowTouchMove: false,
      on: {
        init() {
          playActive(this);
        },
        slideChangeTransitionEnd() {
          playActive(this);
        },
      },
    });

    this.mvSwiperDestroy = () => {
      tls.forEach((tl) => tl.kill());
      currentTL = null;

      if (this.mvSwiper) {
        this.mvSwiper.destroy(true, true);
        this.mvSwiper = null;
      }

      this.mvSwiperEl.dataset.swiperInit = "0";

      this.mvSwiperEl.querySelectorAll(".swiper-slide").forEach((slideEl) => {
        delete slideEl._mvTL;
      });

      this.mvSwiperEl
        .querySelectorAll(
          ".js-mv-swiper__text .in-picture, .js-mv-swiper__people",
        )
        .forEach((el) => {
          gsap.killTweensOf(el);
          gsap.set(el, { clearProps: "all" });
        });
    };
  }
  worksPinInit() {
    this.worksPinDestroy();

    const works = this.root.querySelectorAll(".js-work");
    if (!works.length) return;

    const setCurrent = (activeIndex) => {
      works.forEach((work, index) => {
        work.classList.toggle("is-current", index === activeIndex);
      });
    };

    works.forEach((_, index) => {
      if (index === 0) return;

      const trigger = ScrollTrigger.create({
        trigger: this.worksPinEl,
        start: () => {
          const prevRatio = (index / works.length) * 100;
          return `${prevRatio}% center`;
        },
        end: () => {
          const currentRatio = ((index + 1) / works.length) * 100;
          return `${currentRatio}% center`;
        },
        invalidateOnRefresh: true,
        onEnter: () => setCurrent(index),
        onEnterBack: () => setCurrent(index),
        onLeaveBack: () => setCurrent(index - 1),
      });

      this.worksPinTriggers.push(trigger);
    });

    requestAnimationFrame(() => {
      ScrollTrigger.refresh();
      ScrollTrigger.update();

      const activeTriggerIndex = this.worksPinTriggers.findIndex(
        (trigger) => trigger.isActive,
      );

      if (activeTriggerIndex === -1) {
        setCurrent(0);
      } else {
        setCurrent(activeTriggerIndex + 1);
      }
    });
  }
  worksPinDestroy() {
    if (this.worksPinTriggers.length) {
      this.worksPinTriggers.forEach((trigger) => trigger.kill());
      this.worksPinTriggers = [];
    }

    this.root.querySelectorAll(".js-work").forEach((work) => {
      work.classList.remove("is-current");
    });
  }
  resizeBind() {
    if (this.resizeHandler) return;

    let lastWidth = window.innerWidth;

    this.resizeHandler = this.debounce(() => {
      if (lastWidth === window.innerWidth) return;
      lastWidth = window.innerWidth;

      const shouldResetWorksPinScroll = this.isInWorksPinSection();

      if (this.mvSwiperDestroy) {
        this.mvSwiperDestroy();
        this.mvSwiperInit();
      }

      this.worksPinDestroy();

      const rebuildWorksPin = () => {
        if (this.worksPinEl && !isMobile()) {
          this.worksPinInit();
        }

        requestAnimationFrame(() => {
          ScrollTrigger.refresh();
          ScrollTrigger.update();
        });
      };

      if (shouldResetWorksPinScroll && this.worksPinEl) {
        const top =
          window.scrollY + this.worksPinEl.getBoundingClientRect().top;

        window.scrollTo(0, top);

        requestAnimationFrame(() => {
          rebuildWorksPin();
        });
        return;
      }

      rebuildWorksPin();
    }, 300);

    window.addEventListener("resize", this.resizeHandler);
  }
  isInWorksPinSection() {
    if (!this.worksPinEl) return false;

    const rect = this.worksPinEl.getBoundingClientRect();
    const scrollTop = window.scrollY;
    const sectionTop = scrollTop + rect.top;
    const sectionBottom = sectionTop + this.worksPinEl.offsetHeight;
    const currentScroll = scrollTop;
    const viewportCenter = currentScroll + window.innerHeight / 2;

    return viewportCenter >= sectionTop && viewportCenter <= sectionBottom;
  }
}
